import Carousel from 'react-bootstrap/Carousel';
import $ from 'jquery';
import { useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from "react-i18next";
export default function Products(params) {
    useEffect(()=>{
        var windowHeight = $(window).height();
        $('.carousel img').height(windowHeight);
      
    })
    const { t } = useTranslation();
    return<>
    <div  className='events'>
<Carousel fade>

      <Carousel.Item>
        <img className='d-block w-100' src={require("../Assets/background/Edge-131.jpg")}/>
        <Carousel.Caption data-aos="fade-right">
  
  <h6>{t("Kitchen Botique Project")}</h6>
  <h2>{t("productslider1")}</h2>
  <p>{t("productsliderp1")}</p>

</Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img className='d-block w-100' src={require("../Assets/background/Edge-143.jpg")}/>
      <Carousel.Caption data-aos="fade-right">
  
  <h6>{t("Kitchen Botique Project")}</h6>
  <h2>{t("productslider2")}</h2>
  <p>{t("productsliderp2")}</p>

</Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img className='d-block w-100' src={require("../Assets/background/Edge-357.jpg")}/>
      <Carousel.Caption data-aos="fade-right">
  
  <h6>{t("Kitchen Botique Project")}</h6>
  <h2>{t("productslider3")}</h2>
  <p>{t("productsliderp3")}</p>

</Carousel.Caption>
      </Carousel.Item>
    </Carousel>
   

</div>
       
        <div className="flex flex-4 container products mt-200">
            <div className="item" data-aos="fade-right">
                <div className='itemimg' style={{backgroundImage:`url(${require("../Assets/background/Appliance-Selection.png")})`}}> </div>
                <h1>{t("Kitchens")}</h1>
                <div className='shadow'>
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="40.000000pt" height="40.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="#fff" stroke="none">
<path d="M539 5091 l-29 -29 0 -395 0 -395 -61 -4 -61 -4 -194 -195 -194 -195
0 -153 c0 -153 5 -182 39 -208 12 -10 220 -12 898 -13 l882 0 28 24 c28 24 28
25 31 166 2 78 1 154 -3 169 -7 29 -343 374 -387 397 -15 8 -47 14 -73 14
l-45 0 0 380 c0 405 -3 435 -48 459 -14 7 -144 11 -387 11 l-367 0 -29 -29z
m651 -481 l0 -340 -255 0 -255 0 0 340 0 340 255 0 255 0 0 -340z m372 -657
l148 -147 0 -68 0 -68 -770 0 -770 0 0 67 0 68 147 147 148 148 474 0 474 0
149 -147z"/>
<path d="M2220 4306 l0 -815 -54 -24 c-122 -56 -192 -160 -203 -303 -7 -95 -1
-126 29 -154 21 -19 34 -20 313 -20 290 0 292 0 313 23 11 12 24 40 27 62 9
57 -9 177 -36 233 -32 65 -109 137 -169 159 l-50 18 0 817 0 818 -85 0 -85 0
0 -814z m157 -997 c50 -24 82 -65 90 -114 l6 -35 -172 0 -171 0 6 28 c16 64
46 101 104 126 48 21 86 20 137 -5z"/>
<path d="M2820 4646 l0 -473 -45 -18 c-63 -24 -148 -105 -182 -172 -21 -45
-28 -74 -31 -145 -5 -99 6 -139 44 -157 17 -7 118 -11 305 -11 l280 0 26 26
c24 25 25 28 21 132 -3 99 -6 112 -38 170 -37 70 -92 121 -163 152 l-47 21 0
474 0 475 -85 0 -85 0 0 -474z m160 -658 c47 -24 90 -83 90 -125 0 -23 0 -23
-170 -23 -141 0 -170 2 -170 14 0 27 21 71 48 100 55 59 128 71 202 34z"/>
<path d="M3465 4086 c-17 -7 -36 -25 -43 -40 -9 -21 -12 -256 -12 -1011 l0
-985 -934 0 -934 0 -4 146 -3 146 -28 24 c-28 24 -33 24 -170 22 l-142 -3 -3
-82 -3 -82 88 -3 88 -3 3 -82 3 -83 -176 0 -175 0 0 170 0 170 -85 0 -85 0 0
-170 0 -170 -170 0 -170 0 0 85 0 85 85 0 85 0 0 85 0 85 -141 0 -141 0 -29
-29 -29 -29 0 -141 0 -141 -141 0 -141 0 -29 -29 -29 -29 0 -967 0 -967 29
-29 29 -29 2502 0 2502 0 29 29 29 29 0 1991 0 1990 -24 28 -24 28 -789 2
c-638 2 -794 0 -818 -11z m1483 -673 l2 -513 -685 0 -685 0 0 508 c0 280 3
512 7 515 3 4 311 6 682 5 l676 -3 3 -512z m2 -1963 l0 -1280 -685 0 -685 0 0
1280 0 1280 685 0 685 0 0 -1280z m-3242 258 l2 -168 -770 0 -770 0 0 170 0
170 768 -2 767 -3 3 -167z m1702 2 l0 -170 -765 0 -765 0 0 170 0 170 765 0
765 0 0 -170z m-1702 -942 l2 -598 -770 0 -770 0 0 593 c0 327 3 597 7 600 3
4 349 6 767 5 l761 -3 3 -597z m852 2 l0 -600 -340 0 -340 0 0 600 0 600 340
0 340 0 0 -600z m850 0 l0 -600 -340 0 -340 0 0 593 c0 327 3 597 7 600 3 4
156 7 340 7 l333 0 0 -600z"/>
<path d="M3752 3413 l3 -168 85 0 85 0 3 168 2 167 -90 0 -90 0 2 -167z"/>
<path d="M3757 2384 c-4 -4 -7 -81 -7 -171 l0 -163 90 0 90 0 -2 168 -3 167
-80 3 c-45 1 -84 0 -88 -4z"/>
<path d="M372 1770 c-46 -43 -37 -107 19 -139 51 -29 119 14 119 76 0 70 -87
110 -138 63z"/>
<path d="M705 1758 c-32 -38 -29 -81 11 -115 29 -27 54 -29 93 -8 75 38 43
155 -43 155 -26 0 -40 -7 -61 -32z"/>
<path d="M1062 1774 c-35 -24 -44 -59 -27 -100 35 -85 155 -59 155 35 0 67
-73 104 -128 65z"/>
<path d="M1396 1769 c-49 -38 -28 -130 32 -144 43 -9 81 10 97 49 35 83 -58
151 -129 95z"/>
<path d="M2472 1708 l3 -83 173 -3 172 -2 0 85 0 85 -175 0 -176 0 3 -82z"/>
<path d="M369 1171 l-24 -19 -3 -377 -3 -376 30 -29 29 -30 531 0 c327 0 540
4 556 10 51 19 55 48 55 419 0 187 -4 351 -9 364 -23 60 9 57 -591 57 -524 0
-549 -1 -571 -19z m999 -403 l-3 -253 -427 -3 -428 -2 0 255 0 255 430 0 430
0 -2 -252z"/>
<path d="M2220 770 l0 -170 85 0 85 0 0 170 0 170 -85 0 -85 0 0 -170z"/>
<path d="M2900 770 l0 -170 85 0 85 0 0 170 0 170 -85 0 -85 0 0 -170z"/>
</g>
</svg>

                </div>
            </div>
            <div className="item" data-aos="fade-down-right"><div className='itemimg' style={{backgroundImage:`url(${require("../Assets/background/382994685_644604374527229_7191409569955122554_n.jpg")})`}}></div>
                <h1>{t("Bathrooms")}</h1>
                <div className='shadow'>
                <FontAwesomeIcon icon="fa-solid fa-sink" />
                </div>
                </div>
            <div className="item" data-aos="fade-down-left"><div className='itemimg' style={{backgroundImage:`url(${require("../Assets/background/Edge-103.jpg")})`}}></div>
                <h1>{t("Wardrobes")}</h1>
                <div className='shadow'>
               <svg version="1.0" 
  width="40.000000pt" height="40.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="#fff" stroke="none">
<path d="M197 4596 c-90 -33 -163 -108 -187 -196 -6 -22 -10 -724 -10 -1938
l0 -1903 25 -24 24 -25 2511 0 2511 0 24 25 25 24 0 909 c0 905 0 909 -21 936
-28 36 -80 36 -108 0 -21 -26 -21 -34 -21 -685 l0 -659 -755 0 -755 0 2 1467
3 1468 338 3 337 2 0 -67 0 -68 -250 -129 c-263 -135 -282 -149 -298 -222 -22
-101 44 -192 147 -202 l51 -5 0 -149 c0 -145 1 -150 25 -173 27 -28 42 -30 78
-14 40 18 47 50 47 199 l0 140 280 0 280 0 0 -440 0 -440 -280 0 -280 0 0 145
c0 142 -1 147 -25 170 -31 32 -74 33 -103 2 -21 -22 -22 -32 -22 -225 0 -189
1 -203 20 -222 19 -19 33 -20 409 -20 l390 0 20 26 c21 26 21 36 21 514 l0
487 50 5 c123 12 190 146 126 253 -22 36 -47 52 -277 171 l-254 131 -3 66 -3
67 341 0 340 0 0 -661 c0 -403 4 -667 10 -678 5 -10 22 -24 39 -30 24 -10 34
-10 60 3 17 9 33 26 36 39 3 12 4 407 3 877 l-3 855 -30 53 c-32 59 -66 91
-129 125 -41 22 -42 22 -720 25 -746 3 -730 4 -812 -57 l-38 -29 -37 30 c-72
58 -71 58 -789 58 -719 0 -720 0 -790 -59 l-35 -29 -34 25 c-18 14 -55 34 -82
44 -46 18 -90 19 -717 19 -535 -1 -675 -4 -705 -14z m1390 -156 c18 -10 40
-31 50 -47 17 -25 18 -77 21 -879 2 -792 4 -852 20 -867 9 -8 29 -19 44 -22
22 -6 33 -1 58 23 l30 30 0 661 0 661 338 -2 337 -3 0 -65 0 -65 -237 -120
c-130 -66 -250 -133 -267 -149 -82 -78 -59 -221 42 -270 31 -14 92 -16 536
-16 549 0 544 -1 594 59 65 78 50 200 -32 249 -16 9 -130 69 -255 132 l-226
115 0 68 0 67 335 0 335 0 0 -1470 0 -1470 -750 0 -750 0 -2 664 c-3 637 -4
665 -22 685 -25 27 -79 28 -106 1 -20 -20 -20 -33 -20 -885 l0 -865 -755 0
-755 0 0 535 0 535 98 0 c88 0 104 3 153 27 35 18 64 43 84 71 l30 44 3 171
c4 192 -3 229 -50 283 -53 60 -92 74 -213 74 l-105 0 0 978 c0 927 1 979 18
1011 10 19 34 43 53 53 32 17 73 18 684 18 627 0 651 -1 682 -20z m1660 0 c51
-31 63 -65 63 -185 l0 -105 -750 0 -750 0 0 108 c0 90 3 112 20 140 38 63 20
61 735 62 627 0 651 -1 682 -20z m1652 2 c56 -30 71 -71 71 -189 l0 -103 -756
0 -756 0 3 108 c5 120 16 148 72 182 31 19 55 20 682 20 611 0 652 -1 684 -18z
m-2095 -828 c127 -65 234 -122 238 -127 4 -6 4 -15 2 -19 -3 -4 -221 -8 -485
-8 -438 0 -480 1 -477 16 3 17 449 254 477 254 8 0 118 -52 245 -116z m1661
-2 c150 -76 231 -123 233 -135 3 -16 -26 -17 -478 -17 -453 0 -481 1 -478 18
2 11 81 57 233 134 127 64 237 117 245 117 8 0 118 -52 245 -117z m-4113
-1379 c16 -14 18 -33 18 -165 0 -188 0 -188 -130 -188 l-90 0 0 55 0 55 39 0
c54 0 94 34 94 80 0 45 -32 70 -89 70 l-44 0 0 55 0 55 92 0 c71 0 95 -4 110
-17z m4618 -1448 l0 -125 -1580 0 -1580 0 0 125 0 125 1580 0 1580 0 0 -125z"/>
<path d="M424 4138 c-22 -10 -44 -47 -44 -72 0 -7 9 -25 21 -40 l20 -26 480 0
c466 0 480 1 499 20 27 27 26 81 -1 106 -20 18 -44 19 -488 21 -309 1 -473 -2
-487 -9z"/>
<path d="M424 3798 c-22 -10 -44 -47 -44 -72 0 -7 9 -25 21 -40 l20 -26 480 0
c466 0 480 1 499 20 30 30 27 83 -6 109 -26 21 -36 21 -488 20 -296 0 -469 -4
-482 -11z"/>
<path d="M424 3458 c-22 -10 -44 -47 -44 -72 0 -7 9 -25 21 -40 l20 -26 480 0
c466 0 480 1 499 20 30 30 27 83 -6 109 -26 21 -36 21 -488 20 -296 0 -469 -4
-482 -11z"/>
<path d="M424 3118 c-22 -10 -44 -47 -44 -72 0 -7 9 -25 21 -40 l20 -26 480 0
c466 0 480 1 499 20 30 30 27 83 -6 109 -26 21 -36 21 -488 20 -296 0 -469 -4
-482 -11z"/>
</g>
</svg>
                </div>
                </div>
            <div className="item" data-aos="fade-left"><div className='itemimg' style={{backgroundImage:`url(${require("../Assets/background/868a7a9c72f2c9d73507fc4608025834.jpg")})`}}></div>
                <h1>{t("TV Units")}</h1>
                <div className='shadow'>
                <FontAwesomeIcon icon="fa-solid fa-tv" />
                </div>
                </div>
                {/* Entertainment Console */}
        </div>
        <div className="flex flex-2 container" style={{justifyContent:"space-evenly"}}>
              <a  className="read" href = {require("../Assets/pdf/KB-Catalogue.pdf")} target = "_blank">{t("View Cataloge")}</a>

              </div>
    </>
}